const SKU_REGEX = /^(M)*(EL-)*(BC)*(AZ)*(\d){4,7}(-\w)*$/;

export const matchesSkuRegex = (mightBeSku: string): boolean => SKU_REGEX.test(mightBeSku);
